import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from './Chip';

// Matches the in-app Opportunity card: light gray background, green left rail,
// description on top, "Recommendation:" and "Why we fit:" inline labels below,
// type chip at the bottom.
const OpportunityCard = ({ opportunity, style }) => (
  <View wrap={false} style={[{
    flexDirection: 'row',
    backgroundColor: '#f5f7fa',
    borderRadius: 4,
    overflow: 'hidden',
    marginBottom: space.sm,
  }, style]}>
    <View style={{ width: 3, backgroundColor: colors.success }} />
    <View style={{ flex: 1, paddingVertical: 10, paddingHorizontal: space.md }}>
      <Text style={[type.bodyMed, { color: colors.ink }]}>{opportunity.description}</Text>

      {opportunity.recommendation && (
        <Text style={[type.body, { color: colors.inkSoft, marginTop: 4 }]}>
          <Text style={{ fontWeight: 600, color: colors.ink }}>Recommendation: </Text>
          {opportunity.recommendation}
        </Text>
      )}
      {opportunity.whyWeFit && (
        <Text style={[type.body, { color: colors.inkSoft, marginTop: 4 }]}>
          <Text style={{ fontWeight: 600, color: colors.ink }}>Why we fit: </Text>
          {opportunity.whyWeFit}
        </Text>
      )}

      {opportunity.type && (
        <View style={{ alignSelf: 'flex-start', marginTop: 6 }}>
          <Chip variant="success">{opportunity.type}</Chip>
        </View>
      )}
    </View>
  </View>
);

export default OpportunityCard;
